import { jsx as _jsx } from "react/jsx-runtime";
import MuiRadio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { withStyles } from "tss-react/mui";
export { RadioGroup };
const StyledMuiRadio = withStyles(MuiRadio, {
    root: {
        "&.Mui-checked": {
            // $color-ploom-blue
            color: "#3567ff",
        },
    },
    checked: {},
}, {
    name: "Radio",
});
export const Radio = (props) => _jsx(StyledMuiRadio, { color: "default", ...props });
//# sourceMappingURL=Radio.js.map